module.exports = __webpack_public_path__ + "img/afcfta_caravan.0cb32ea1.png";